import styled from 'styled-components';
import ModalBase from '../ModalBase';
import { IoMdClose } from 'react-icons/io';
import SquareButton from '../../../button/SquareButton';
import { NoticeCommentRequestType } from '../../../../api/apiConfig';
import { useState } from 'react';

export type NoticeCommentEditModalPropsType = {
  data: NoticeCommentRequestType | null;
  onSave: (data: NoticeCommentRequestType) => void;
  onClose: () => void;
};

export const NoticeCommentEditModal = ({
  data,
  onSave,
  onClose,
}: NoticeCommentEditModalPropsType) => {
  const [resData, setResData] = useState<NoticeCommentRequestType | null>(data);

  if (resData === null) return;

  return (
    <ModalBase>
      <Container>
        <HeaderArea>
          <HeaderTitle>댓글 수정</HeaderTitle>
        </HeaderArea>
        <SubTitle>내용</SubTitle>
        <MainInput
          value={resData.detail}
          onChange={(e) => setResData({ ...resData, detail: e.target.value })}
        />
        <ButtonContainer>
          <SquareButton
            colorType='ACTIVE'
            onClick={() => onSave(resData)}
            text='저장'
            width={150}
            height={30}
            radius={5}
          />
          <SquareButton
            colorType='ACTIVE_WARN'
            onClick={() => onClose()}
            text='취소'
            width={150}
            height={30}
            radius={5}
          />
        </ButtonContainer>
      </Container>
    </ModalBase>
  );
};

const Container = styled.div`
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  width: 600px;
  height: 300px;
  background-color: #f1f1f1;
  padding: 15px;
  display: flex;
  flex-direction: column;
`;

const HeaderArea = styled.div`
  /* display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between; */
  /* padding: 10px 15px; */
`;

const HeaderTitle = styled.h2`
  color: ${({ theme }) => theme.colors.charcoal};
  margin: 0;
  margin-bottom: 15px;
`;

const SubTitle = styled.h3`
  color: ${({ theme }) => theme.colors.charcoal};
  margin: 0;
  margin-bottom: 15px;
`;

const TitleInput = styled.input`
  border: none;
  outline: none; /* 포커스 시 기본 아웃라인 제거 */
  padding: 5px 8px;
`;

const MainInput = styled.textarea`
  flex: 1;
  resize: none;
  border: none;
  border-bottom: 1px solid #c3c3c3; /* 하단 보더 추가 */
  font-size: 16px;
  padding: 5px 8px; /* 입력 내용과 보더 간격 조정 */
  outline: none; /* 포커스 시 기본 아웃라인 제거 */
  width: 100%; /* 가로 크기 조절 */

  &:focus {
    border-bottom: none; /* 포커스 시 보더 색상 변경 */
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 15px;
  gap: 40px;

  justify-content: center;
`;
